import { IconBack } from "@suse-o11y/icons";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import { useDelayed } from "@suse-o11y/use-delayed";
import React from "react";

import { useGoBackInChain } from "../../../../app/state/right-pane/hooks";

const LABEL = "Back to previous selection";

export const EastPaneBackButton: React.FC<{
	compact?: boolean;
}> = ({ compact = false }) => {
	const goBackInChain = useGoBackInChain();
	const delayedCompact = useDelayed(compact, 500, {
		fallback: true,
	});

	return (
		<TooltipBoundary>
			<TooltipTrigger
				aria-label={LABEL}
				className="mr-1 -ml-2 inline-flex h-[38px] cursor-pointer items-center justify-center gap-2 rounded-sm border border-transparent border-solid bg-grey-200 px-1 py-0 text-grey-900 text-lg leading-none transition hover:text-primary-500 focus-visible:border-primary-500 focus-visible:text-primary-500"
				onClick={goBackInChain}
			>
				<IconBack />

				{!delayedCompact && <span className="text-13 underline">Previous</span>}
			</TooltipTrigger>

			<Tooltip className="tooltip/tooltip">{LABEL}</Tooltip>
		</TooltipBoundary>
	);
};
